import { lazyGetDensitySections } from "owa-mail-ribbon-sections/lib/sections";
import type { MailboxInfo } from "owa-client-types";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";

export const onDensityMenuClicked = (mailboxInfo: MailboxInfo): void => {
    lazyGetDensitySections.import().then(getDensitySections => {
        setMenuDefinition("DensityMenuDefinitionStore", undefined /* projectionTabId */, () => {
            return {
                sections: getDensitySections(mailboxInfo),
            };
        });
    });
};
